// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1UGlE","label":"CategoryService_label__35XzF","location":"CategoryService_location__2SZzE"};